import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
import { CategoriesDataService } from './categories-data.service';
import { Category, CategoriesResult } from '../interfaces';
import { SubCategoriesDataService } from './sub-categories-data.service';
import { SubCategory, SubCategoriesResult } from '../interfaces';
import { Experts, ExpertsResult } from '../interfaces';
import { VideoTypesDataService } from './video-types-data.service';
import { VideoType, VideoTypesResult } from '../interfaces';
import { PricesDataService } from './prices-data.service';
import { Price, PricesResult } from '../interfaces';
import { SharingsDataService } from './sharings-data.service';
import { Sharing, SharingsResult } from '../interfaces';
import { ShowsDataService } from './shows-data.service';
import { Show, ShowsResult } from '../interfaces';
import { UsersDataService } from './users-data.service';
import { User, UsersResult } from '../interfaces';
import { ExpertsDataService } from './experts-data.service';
import { VideosDataService } from './videos-data.service';
import { Video, VideosResult } from '../interfaces';


@Injectable({
  providedIn: 'root'
})
export class VideosColumnsService {

  public categories: Category[] = [];
  public subCategories: SubCategory[] = [];
  public experts: Experts[] = [];
  public videoTypes: VideoType[] = [];
  public prices: Price[] = [];
  public sharings: Sharing[] = [];
  public shows: Show[] = [];
  public users: User[] = [];
  public videos: Video[] = [];

  public statusesOptions = [{
    value: 'Draft',
    label: 'STATUSESDRAFT',
    css: 'primary'
  }, {
    value: 'Online',
    label: 'STATUSESONLINE',
    css: 'success'
  }, {
    value: 'Deactivated',
    label: 'STATUSESDEACTIVATED',
    css: 'warning'
  }, {
    value: 'Offline',
    label: 'STATUSESOFFLINE',
    css: 'danger'
  }, {
    value: 'Deleted',
    label: 'STATUSESDELETED',
    css: 'default'
  }, {
    value: 'Archived',
    label: 'STATUSESARCHIVED',
    css: 'info'
  }];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private cache: CacheService,
    private common: CommonService,
    private categoriesDataService: CategoriesDataService,
    private subCategoriesDataService: SubCategoriesDataService,
    private videoTypesDataService: VideoTypesDataService,
    private pricesDataService: PricesDataService,
    private sharingsDataService: SharingsDataService,
    private showsDataService: ShowsDataService,
    private usersDataService: UsersDataService,
    private expertsDataService: ExpertsDataService,
    private videosDataService: VideosDataService

  ) {
    this.getCategories()
    this.getSubCategories()
    this.getVideoTypes()
    this.getPrices()
    this.getSharings()
    this.getShows()
    this.getUsers()
    this.getExperts()
    this.getVideos()
  }

    getVideos(offset: number = 0): void {
       const cacheKey: string = 'categories.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.categories = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.videosDataService.getVideos(parameters).subscribe((response: VideosResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.videos = response.results;
        } else {
          this.videos = this.videos.concat(response.results);
        }
        if (response.inlineCount > this.videos.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getVideos(offset);
        }
        response.results = this.videos;
        this.cache.set(cacheKey, response);
      }
    });
    }

  getCategories(offset: number = 0): void {
    const cacheKey: string = 'categories.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.categories = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.categoriesDataService.getCategories(parameters).subscribe((response: CategoriesResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.categories = response.results;
        } else {
          this.categories = this.categories.concat(response.results);
        }
        if (response.inlineCount > this.categories.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getCategories(offset);
        }
        response.results = this.categories;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getSubCategories(offset: number = 0): void {
    const cacheKey: string = 'subCategories.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.subCategories = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.subCategoriesDataService.getSubCategories(parameters).subscribe((response: SubCategoriesResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.subCategories = response.results;
        } else {
          this.subCategories = this.subCategories.concat(response.results);
        }
        if (response.inlineCount > this.subCategories.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getSubCategories(offset);
        }
        response.results = this.subCategories;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getVideoTypes(offset: number = 0): void {
    const cacheKey: string = 'videoTypes.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.videoTypes = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.videoTypesDataService.getVideoTypes(parameters).subscribe((response: VideoTypesResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.videoTypes = response.results;
        } else {
          this.videoTypes = this.videoTypes.concat(response.results);
        }
        if (response.inlineCount > this.videoTypes.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getVideoTypes(offset);
        }
        response.results = this.videoTypes;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getPrices(offset: number = 0): void {
    const cacheKey: string = 'prices.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.prices = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.pricesDataService.getPrices(parameters).subscribe((response: PricesResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.prices = response.results;
        } else {
          this.prices = this.prices.concat(response.results);
        }
        if (response.inlineCount > this.prices.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getPrices(offset);
        }
        response.results = this.prices;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getSharings(offset: number = 0): void {
    const cacheKey: string = 'sharings.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.sharings = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.sharingsDataService.getSharings(parameters).subscribe((response: SharingsResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.sharings = response.results;
        } else {
          this.sharings = this.sharings.concat(response.results);
        }
        if (response.inlineCount > this.sharings.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getSharings(offset);
        }
        response.results = this.sharings;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getShows(offset: number = 0): void {
    const cacheKey: string = 'shows.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.shows = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.showsDataService.getShows(parameters).subscribe((response: ShowsResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.shows = response.results;
        } else {
          this.shows = this.shows.concat(response.results);
        }
        if (response.inlineCount > this.shows.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getShows(offset);
        }
        response.results = this.shows;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getUsers(offset: number = 0): void {
    const cacheKey: string = 'users.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.users = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.usersDataService.getUsers(parameters).subscribe((response: UsersResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.users = response.results;
        } else {
          this.users = this.users.concat(response.results);
        }
        if (response.inlineCount > this.users.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getUsers(offset);
        }
        response.results = this.users;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getExperts(offset: number = 0): void {
    const cacheKey: string = 'experts.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.experts = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, { offset: offset + '' });
    this.expertsDataService.getExperts(parameters).subscribe((response: ExpertsResult | any) => {
      if (response !== null) {
        if (offset === 0) {
          this.experts = response.results;
        } else {
          this.experts = this.experts.concat(response.results);
        }
        if (response.inlineCount > this.experts.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getExperts(offset);
        }
        response.results = this.experts;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getColumns(): Column[] {
    return [
      { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('videos.id.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'show', title: this.translate.instant('SHOW'), type: 'linkValue', filterData: this.shows, show: (this.navigation.getParamValue('videos.showId.showFiled', true) && true), displayInList: true, filterField: 'show.id', displayField: 'name', sortField: 'show.name', url: 'shows' },
      { field: 'videoType', title: this.translate.instant('VIDEOTYPE'), type: 'linkValue', filterData: this.videoTypes, show: (this.navigation.getParamValue('videos.videoTypeId.showFiled', true) && (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') > -1)), displayInList: (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') > -1), filterField: 'videoType.id', displayField: 'name', sortField: 'videoType.name', url: 'video-types' },
      { field: 'price', title: this.translate.instant('PRICE'), type: 'linkValue', filterData: this.prices, show: (this.navigation.getParamValue('videos.priceId.showFiled', true) && (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') > -1)), displayInList: (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') > -1), filterField: 'price.id', displayField: 'name', sortField: 'price.name', url: 'prices' },
      { field: 'sharing', title: this.translate.instant('SHARING'), type: 'linkValue', filterData: this.sharings, show: (this.navigation.getParamValue('videos.sharingId.showFiled', true) && (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') > -1)), displayInList: (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') > -1), filterField: 'sharing.id', displayField: 'name', sortField: 'sharing.name', url: 'sharings' },
      { field: 'name', sortField: 'name', title: this.translate.instant('NAME'), show: (this.navigation.getParamValue('videos.name.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'nameAr', sortField: 'nameAr', title: this.translate.instant('NAMEAR'), show: (this.navigation.getParamValue('videos.nameAr.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'nameFr', sortField: 'nameFr', title: this.translate.instant('NAMEFR'), show: (this.navigation.getParamValue('videos.nameFr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'duration', sortField: 'duration', title: this.translate.instant('DURATION'), show: (this.navigation.getParamValue('videos.duration.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'picture', sortField: 'picture', title: this.translate.instant('PICTURE'), show: (this.navigation.getParamValue('videos.picture.showFiled', false) && true), displayInList: true, type: 'imgValue'},
      { field: 'watermarkText', sortField: 'watermarkText', title: this.translate.instant('WATERMARKTEXT'), show: (this.navigation.getParamValue('videos.watermarkText.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'file', sortField: 'file', title: this.translate.instant('FILE'), show: (this.navigation.getParamValue('videos.file.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'fileAr', sortField: 'fileAr', title: this.translate.instant('FILEAR'), show: (this.navigation.getParamValue('videos.fileAr.showFiled', false) && true), displayInList: true, type: 'textValue' },
      { field: 'fileSize', sortField: 'fileSize', title: this.translate.instant('FILESIZE'), show: (this.navigation.getParamValue('videos.fileSize.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'description', sortField: 'description', title: this.translate.instant('DESCRIPTION'), show: (this.navigation.getParamValue('videos.description.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionAr', sortField: 'descriptionAr', title: this.translate.instant('DESCRIPTIONAR'), show: (this.navigation.getParamValue('videos.descriptionAr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'descriptionFr', sortField: 'descriptionFr', title: this.translate.instant('DESCRIPTIONFR'), show: (this.navigation.getParamValue('videos.descriptionFr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'enableStreaming', sortField: 'enableStreaming', title: this.translate.instant('ENABLESTREAMING'), show: (this.navigation.getParamValue('videos.enableStreaming.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'seasonNumber', sortField: 'seasonNumber', title: this.translate.instant('SEASONNUMBER'), show: (this.navigation.getParamValue('videos.seasonNumber.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'episodeNumber', sortField: 'episodeNumber', title: this.translate.instant('EPISODENUMBER'), show: (this.navigation.getParamValue('videos.episodeNumber.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'isTop', sortField: 'isTop', title: this.translate.instant('ISTOP'), show: (this.navigation.getParamValue('videos.isTop.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'isNew', sortField: 'isNew', title: this.translate.instant('ISNEW'), show: (this.navigation.getParamValue('videos.isNew.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'status', sortField: 'status', title: this.translate.instant('STATUS'), show: (this.navigation.getParamValue('videos.status.showFiled', false) && (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_PUBLISHER') > -1)), displayInList: (this.common.currentUser.roles.join('').indexOf('ROLE_ADMIN_PUBLISHER') > -1), type: 'enumValue', filterData: this.statusesOptions},
      { field: 'autoPublishing', sortField: 'autoPublishing', title: this.translate.instant('AUTOPUBLISHING'), show: (this.navigation.getParamValue('videos.autoPublishing.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'startPublishing', sortField: 'startPublishing', title: this.translate.instant('STARTPUBLISHING'), show: (this.navigation.getParamValue('videos.startPublishing.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'endPublishing', sortField: 'endPublishing', title: this.translate.instant('ENDPUBLISHING'), show: (this.navigation.getParamValue('videos.endPublishing.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'totalPreviewed', sortField: 'totalPreviewed', title: this.translate.instant('TOTALPREVIEWED'), show: (this.navigation.getParamValue('videos.totalPreviewed.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'totalDownloads', sortField: 'totalDownloads', title: this.translate.instant('TOTALDOWNLOADS'), show: (this.navigation.getParamValue('videos.totalDownloads.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'totalHits', sortField: 'totalHits', title: this.translate.instant('TOTALHITS'), show: (this.navigation.getParamValue('videos.totalHits.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'totalComments', sortField: 'totalComments', title: this.translate.instant('TOTALCOMMENTS'), show: (this.navigation.getParamValue('videos.totalComments.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'totalRatings', sortField: 'totalRatings', title: this.translate.instant('TOTALRATINGS'), show: (this.navigation.getParamValue('videos.totalRatings.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'averageRatings', sortField: 'averageRatings', title: this.translate.instant('AVERAGERATINGS'), show: (this.navigation.getParamValue('videos.averageRatings.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'totalLikes', sortField: 'totalLikes', title: this.translate.instant('TOTALLIKES'), show: (this.navigation.getParamValue('videos.totalLikes.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'totalDislikes', sortField: 'totalDislikes', title: this.translate.instant('TOTALDISLIKES'), show: (this.navigation.getParamValue('videos.totalDislikes.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'totalBookmarks', sortField: 'totalBookmarks', title: this.translate.instant('TOTALBOOKMARKS'), show: (this.navigation.getParamValue('videos.totalBookmarks.showFiled', false) && true), displayInList: true, type: 'numericValue'},
      { field: 'slug', sortField: 'slug', title: this.translate.instant('SLUG'), show: (this.navigation.getParamValue('videos.slug.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'slugAr', sortField: 'slugAr', title: this.translate.instant('SLUGAR'), show: (this.navigation.getParamValue('videos.slugAr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'slugFr', sortField: 'slugFr', title: this.translate.instant('SLUGFR'), show: (this.navigation.getParamValue('videos.slugFr.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'remoteSource', sortField: 'remoteSource', title: this.translate.instant('REMOTESOURCE'), show: (this.navigation.getParamValue('videos.remoteSource.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'url', sortField: 'url', title: this.translate.instant('URL'), show: (this.navigation.getParamValue('videos.url.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'alternativeUrl', sortField: 'alternativeUrl', title: this.translate.instant('ALTERNATIVEURL'), show: (this.navigation.getParamValue('videos.alternativeUrl.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'copyright', sortField: 'copyright', title: this.translate.instant('COPYRIGHT'), show: (this.navigation.getParamValue('videos.copyright.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'category', title: this.translate.instant('CATEGORY'), type: 'linkValue', filterData: this.categories, show: (this.navigation.getParamValue('videos.category.showFiled', false) && true), displayInList: true, filterField: 'category.id', displayField: 'name', sortField: 'category.name', url: 'categories' },
      { field: 'subCategory', title: this.translate.instant('SUBCATEGORY'), type: 'linkValue', filterData: this.subCategories, show: (this.navigation.getParamValue('videos.subCategory.showFiled', false) && true), displayInList: true, filterField: 'subCategory.id', displayField: 'name', sortField: 'subCategory.name', url: 'sub-categories' },
      { field: 'experts', title: this.translate.instant('EXPERT'), type: 'linkValue', filterData: this.experts, show: (this.navigation.getParamValue('posts.expertsId.showFiled', false) && true), displayInList: true, filterField: 'experts.id', displayField: 'name', sortField: 'experts.name', url: 'experts' },
      { field: 'createdAt', sortField: 'createdAt', title: this.translate.instant('CREATEDAT'), show: (this.navigation.getParamValue('videos.createdAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'creatorUser', title: this.translate.instant('CREATORUSER'), type: 'linkValue', filterData: this.users, show: (this.navigation.getParamValue('videos.creatorUser.showFiled', false) && true), displayInList: true, filterField: 'creatorUser.id', displayField: 'username', sortField: 'creatorUser.username', url: 'users' },
      { field: 'modifiedAt', sortField: 'modifiedAt', title: this.translate.instant('MODIFIEDAT'), show: (this.navigation.getParamValue('videos.modifiedAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'modifierUser', title: this.translate.instant('MODIFIERUSER'), type: 'linkValue', filterData: this.users, show: (this.navigation.getParamValue('videos.modifierUser.showFiled', false) && true), displayInList: true, filterField: 'modifierUser.id', displayField: 'username', sortField: 'modifierUser.username', url: 'users' },
      { field: 'actions', title: this.translate.instant('ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null},
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
